import React from 'react'
import i18n from 'simple-react-i18n'
import ParameterCard from '../ParameterCard'
import PropTypes from 'prop-types'
import ParameterWithSimpleInput from '../inputs/ParameterWithSimpleInput'

const CartographyParameters = ({
    isGlobal = false,
    defaultProps = {},
}) => (
    <ParameterCard title={i18n.cartography} isGlobal={isGlobal}>
        <ParameterWithSimpleInput
            {...defaultProps}
            parameter='defaultMapXCoordinate'
            title={i18n.defaultAxis}
            placeholder='2.6013202230563772'
        />
        <ParameterWithSimpleInput
            {...defaultProps}
            parameter='defaultMapYCoordinate'
            title={i18n.defaultOrderedAxis}
            placeholder='48.01685291740509'
        />
        <ParameterWithSimpleInput
            {...defaultProps}
            parameter='defaultMapZoom'
            title={i18n.defaultZoom}
            placeholder='6.070309681714787'
        />
    </ParameterCard>
)

CartographyParameters.propTypes = {
    isGlobal: PropTypes.bool,
    defaultProps: PropTypes.shape({}),
}

export default CartographyParameters
